/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppState } from './AppState';
import {
    AppStateFromJSON,
    AppStateFromJSONTyped,
    AppStateToJSON,
} from './AppState';
import type { Message } from './Message';
import {
    MessageFromJSON,
    MessageFromJSONTyped,
    MessageToJSON,
} from './Message';
import type { PayloadTypeConstants } from './PayloadTypeConstants';
import {
    PayloadTypeConstantsFromJSON,
    PayloadTypeConstantsFromJSONTyped,
    PayloadTypeConstantsToJSON,
} from './PayloadTypeConstants';

/**
 * 
 * @export
 * @interface AppStateResponse
 */
export interface AppStateResponse {
    /**
     * 
     * @type {PayloadTypeConstants}
     * @memberof AppStateResponse
     */
    type: PayloadTypeConstants;
    /**
     * 
     * @type {Array<Message>}
     * @memberof AppStateResponse
     */
    messages: Array<Message>;
    /**
     * 
     * @type {AppState}
     * @memberof AppStateResponse
     */
    payload?: AppState;
}

/**
 * Check if a given object implements the AppStateResponse interface.
 */
export function instanceOfAppStateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "messages" in value;

    return isInstance;
}

export function AppStateResponseFromJSON(json: any): AppStateResponse {
    return AppStateResponseFromJSONTyped(json, false);
}

export function AppStateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppStateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': PayloadTypeConstantsFromJSON(json['type']),
        'messages': ((json['messages'] as Array<any>).map(MessageFromJSON)),
        'payload': !exists(json, 'payload') ? undefined : AppStateFromJSON(json['payload']),
    };
}

export function AppStateResponseToJSON(value?: AppStateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': PayloadTypeConstantsToJSON(value.type),
        'messages': ((value.messages as Array<any>).map(MessageToJSON)),
        'payload': AppStateToJSON(value.payload),
    };
}

